export default {
  PURCHASE_ORDERS: 'PurchaseOrders',
  GOOD_RECEIPTS: 'IntakeDockets',
  SALE_ORDERS: 'SaleOrders',
  DELIVERY_DOCKETS: 'DispatchDockets',
};
